module.exports = __webpack_public_path__ + "static/media/about.b5350396.gif";